export default {
  工作台: 'Workbench',
  线索: 'Clue',
  销售线索: 'Sales Clue',
  销售线索详情: 'Sales Clue Details',
  线索池: 'Clue Pool',
  客户: 'Customer',
  客户管理: 'Customer Management',
  客户详情: 'Customer Details',
  客户公海: 'Customer Public Sea',
  商机: 'Business Opportunity',
  商机管理: 'Business Opportunity Management',
  商机详情: 'Business Opportunity Details',
  报价单: 'Quotation',
  报价单管理: 'Quotation Management',
  报价单详情: 'Quotation Details',
  报价单更新: 'Quotation Update',
  销售合同: 'Sales Contract',
  销售合同管理: 'Sales Contract Management',
  销售合同详情: 'Sales Contract Details',
  更新销售合同: 'Update Sales Contract',
  产品: 'Product',
  产品管理: 'Product Management',
  产品管理详情: 'Product Management Details',
  工作日程: 'Work Schedule',
  日历看板: 'Calendar Kanban',
  日程列表: 'Schedule List',
  通话列表: 'Call List',
  数据分析: 'Data Analysis',
  线索分析: 'Clue Analysis',
  客户画像: 'Customer Portrait',
  成员榜单: 'Member List',
  设置中心: 'Setting Center',
  组织权限: 'Organization Permissions',
  组织用户: 'Organization User',
  已离职用户: 'Departed User',
  角色权限: 'Role Permissions',
  对象管理: 'Object Management',
  系统对象: 'System Object',
  对象详情: 'Object Details',
  外部对象: 'External Object',
  审批模板: 'Approval template',
  映射规则: 'Mapping rules',
  对象下字段: 'Field Under Object',
  全局字段: 'Global Field',
  线索池管理: 'Lead Pool',
  规则管理: 'Rule Management',
  对象映射规则: 'Object Mapping Rule',
  对象映射规则设置: 'Object Mapping Rule Setting',
  对象映射规则详情: 'Object Mapping Rule Details',
  接口映射规则: 'Interface Mapping Rule',
  接口映射规则设置: 'Interface Mapping Rule Setting',
  添加接口映射规则: 'Add Interface Mapping Rule',
  编辑接口映射规则: 'Edit Interface Mapping Rule',
  业务插件管理: 'Business Plugin Management',
  火山外呼人员管理: 'Volcano Outbound Call Personnel Management',
  火山外呼池管理: 'Volcano Outbound Call Pool Management',
  外呼号码管理: 'Outbound Call Number Management',
  流程管理: 'Process Management',
  阶段流程设置: 'Stage Process Setting',
  商机阶段详情: 'Business Opportunity Stage Details',
  火山语音费用: 'Cost Center',
  费用概览: 'Cost Overview',
  账单明细: 'Bill Details',
  e签宝电子签章: 'E-Signature Treasure Electronic Signature',
  自动化流程: 'Automate the Process',
  自动化管理: 'Automation Management',
  返回首页: 'Return to Homepage'
};
